import React, {useEffect, useState} from "react";
import {observer} from "mobx-react-lite";
import intl from "react-intl-universal";
import {useAppState} from "@stores/AppStateContext";

import Modal from '@mui/joy/Modal';
import ModalDialog from "@mui/joy/ModalDialog";

import {useFileProvider} from "../../../../stores/AppStateContext";

import {DownloadIcon} from "../../../components/icons/DownloadIcon";
import {CancelIcon} from "../../../components/icons/CancelIcon";
import {Tooltip} from "../../../components/Tooltip"


import './ImagePreview.css';


export interface ImagePreviewProps {
    s3FileName: string;
}

export const ImagePreview = observer((props: ImagePreviewProps) => {
    const appState = useAppState();
    const fileProvider = useFileProvider();
    const [src, setSrc] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (props.s3FileName && fileProvider) {
            fileProvider.getSignedUrl(props.s3FileName).then((src) => {
                setSrc(src);
            });
        }
    }, [props.s3FileName, fileProvider])
    const onClose = () => {
        appState.setModal(null);
    }
    const downloadImage = () => {
        fileProvider?.downloadFile(src!, props.s3FileName);
    }

    const activeModal = appState.topModal;

    return (
        <Modal
            open={activeModal === 'image-preview'}
            onClose={onClose}
        >
            <ModalDialog
                layout={'fullscreen'}
            >
                <div
                    className={'ImagePreview'}
                    onClick={onClose}
                >
                    <img className={'ImagePreview-img'} src={src} alt=''/>
                </div>
                <div className={'ImagePreview-btn'}>
                    <Tooltip title={intl.get('tooltip.imagePreview.downloadImage').d("Download Image")} isInBox={false}>
                        <DownloadIcon className={'ImagePreview-icon'} size={24} onClick={downloadImage}/>
                    </Tooltip>
                    <Tooltip title={intl.get('tooltip.imagePreview.close').d("Close")} isInBox={false}>
                        <CancelIcon size={24} onClick={onClose}/>
                    </Tooltip>
                </div>
            </ModalDialog>
        </Modal>
    )
})
